<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="cotisations"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #company="{ record }">
        <div style="color: black; font-weight: #2b3e50">
          {{ record.company.name }}
        </div>
        <div style="color: #647c92">{{ record.company.internal_number }}</div>
      </template>

      <template #contract="{ record }">
        <div style="color: black; font-weight: #2b3e50">
          {{ record.contract.name }}
        </div>
        <div style="color: #647c92">{{ record.contract.internal_number }}</div>
      </template>

      <template #total="{ record }">
        <div style="color: green">
          <span v-money-format="record.total"></span> €
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>

const columns = [
  {
    title: "Entreprises",
    width: 220,
    sorter: true,
    dataIndex: "company",
    key: "company",
    defaultSortOrder: "ascend",
    slots: {
      customRender: "company",
    },
  },
  {
    title: "Contrats",
    width: 220,
    sorter: false,
    dataIndex: "contract",
    key: "contract",
    slots: {
      customRender: "contract",
    },
  },
  {
    title: "Types",
    width: 100,
    dataIndex: "contract_type",
    key: "contract_type",
    align: "contract_type",
    slots: {
      customRender: "contract_type",
    },
  },
  {
    title: "Catégories",
    width: 100,
    dataIndex: "contract_category",
    key: "contract_category",
    align: "right",
  },
  {
    title: "Collèges",
    width: 100,
    dataIndex: "contract_college",
    key: "contract_college",
    align: "right",
  },
  {
    title: "Montants encaissés",
    width: 100,
    dataIndex: "total",
    key: "total",
    align: "right",
    slots: {
      customRender: "total",
    },
  },
  {
    title: "Dates de l'encaissement",
    width: 100,
    dataIndex: "pay_date",
    key: "pay_date",
    align: "right",
  },
  {
    title: "Statuts cotisation",
    width: 100,
    dataIndex: "status",
    key: "status",
    align: "right",
  },
  {
    title: "DSN  ",
    width: 100,
    dataIndex: "dsn",
    key: "dsn",
    align: "center",
  },
  {
    title: "Modes de règlement",
    width: 100,
    dataIndex: "dsn_type",
    key: "dsn_type",
    align: "right",
  },
  {
    title: "Début de période",
    width: 100,
    dataIndex: "start_date",
    key: "start_date",
    align: "right",
  },
  {
    title: "Fin de période",
    width: 100,
    dataIndex: "end_date",
    key: "end_date",
    align: "right",
  },
];

export default {
  name: "CotisationTableCol",
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      columns,

      sort: {
        columnKey: null,
        order: null,
      },

      cotisationsData: {
        data: [],
      },

      loading: false,

      timeout: 0,
    };
  },
  watch: {
    spaEr(_) {
      // Reset Pagination
      this.params.page = 1;
      this.getCotisations();
    },
    _searchValue(_) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.params.page = 1;
        this.getCotisations();
      }, 500);
    },
  },
  methods: {
    getCotisations() {
      this.loading = true;

      let url = `data/cotisations/collective/${
        this.numHolding
      }/?${new URLSearchParams(this.params)}`;

      if (this.$route.params.subPage === "etc") {
        url = `data/cotisations/collective/${this.numHolding}/${
          this.numEntreprise
        }/?${new URLSearchParams(this.params)}`;
      }

      if (this.$route.params.subPage === "ctc") {
        url = `data/cotisations/collective/${this.numHolding}/${
          this.numEntreprise
        }/${this.numContract}/?${new URLSearchParams(this.params)}`;
      }

      if (this.$route.params.subPage === "at") {
        url = `data/cotisations/collective/no_paid/?${new URLSearchParams(this.params)}`;
      }

      this.axios.get(url).then((r) => {
        if (r.status === 200) {
          this.cotisationsData = r.data;

          setTimeout(() => {
            this.loading = false;
          }, 100);
        }
      });
    },
    handleTableChange(pag, filters, sorter) {
      this.loading = true;
      this.sort.columnKey = sorter.columnKey;
      this.sort.order = sorter.order;

      this.params.page = pag.current;

      this.getCotisations();
    },
  },
  computed: {
    _searchValue() {
      return this.params.searchValue;
    },
    spaEr() {
      return this.params.spaEr.spa + this.params.spaEr.er.status;
    },
    numHolding() {
      return this.$route.params.numHolding;
    },
    numEntreprise() {
      return this.$route.params.numEntreprise;
    },
    numContract() {
      return this.$route.params.numContrat;
    },
    headers() {
      return this.$store.getters.headers.hhp;
    },
    ac() {
      return this.$store.getters.activeColumns.h;
    },
    noZeroData() {
      return this.$store.getters.noZeroData.h;
    },
    pagination() {
      return {
        total: this.cotisationsData.total,
        current: this.cotisationsData.current_page,
        columnKey: this.params.columnKey,
        order: this.params.order,
      };
    },
    translate() {
      return this.$store.getters.translate;
    },
    cotisations() {
      return this.cotisationsData.data.filter((c) => {
        c.contract_type = c.contract.type;
        c.contract_category = this.translate.category[c.contract.category];
        c.contract_college = this.translate.college[c.contract.college];
        c.dsn_type = this.translate.modeReglement[c.dsn_type];
        c.status = this.translate.etatCotisation[c.status];
        return c;
      });
    },
  },
  mounted() {
    this.getCotisations();
  },
};
</script>

<style>
.ant-table-tbody > tr > td {
  padding: 4px 16px !important;
}

.ant-table-tbody > tr > td {
  border-bottom: 4px solid #f1f1f1 !important;
  white-space: nowrap;
}

.ant-table td {
  white-space: nowrap;
}
.ui.basic.blue.button.plus {
  margin: auto;
  margin: 10px 0 0 48%;
}
</style>
